import { CirclePauseIcon } from "@xola/icons";
import { Button, Tooltip } from "@xola/ui-kit";
import { PurchaseItemStatus } from "common";
import React from "react";
import { ExperiencePurchaseItem, Purchase } from "types";
import { useVisibility } from "../../../hooks/useVisibility";
import { StatusIcon } from "../../PurchasesMenu/PurchaseStatusIcon";
import { PendingPurchaseModal } from "../PendingPurchaseModal";

interface RosterGuestBookingStatusProps {
    purchase: Purchase;
    purchaseItem: ExperiencePurchaseItem;
}

export const RosterGuestBookingStatus = ({ purchase, purchaseItem }: RosterGuestBookingStatusProps) => {
    const [isConfirmBookingModalOpen, { toggle: toggleConfirmBookingModal }] = useVisibility(false);
    const isBookingPending =
        purchaseItem.status === PurchaseItemStatus.PENDING_ACCEPT ||
        purchaseItem.status === PurchaseItemStatus.PENDING_MINIMUM;

    const tooltipContent =
        purchaseItem.status === PurchaseItemStatus.PENDING_ACCEPT ? "Pending Confirmation" : "Pending Minimum";

    return (
        <>
            {isBookingPending ? (
                <Tooltip className="mt-1 flex" content={tooltipContent} placement="auto">
                    <Button
                        className="text-black"
                        color="warning"
                        size="small"
                        icon={<CirclePauseIcon />}
                        onClick={toggleConfirmBookingModal}
                    >
                        Pending
                    </Button>
                </Tooltip>
            ) : (
                <StatusIcon item={purchaseItem} />
            )}
            <PendingPurchaseModal
                purchase={purchase}
                item={purchaseItem}
                isOpen={isConfirmBookingModalOpen}
                onClose={toggleConfirmBookingModal}
            />
        </>
    );
};
